export { ORGANIC_COTTON_BABY_DOLL_COLOR_MAP } from './organicCottonBabyDollOptions';
